<template>
	<section class="grid-group">
		<header class="grid-group-title">
			<div class="grid-group-title__title">{{ title }}</div>
			<div class="grid-group-title__options"><slot name="options"></slot></div>
		</header>
		<main>
			<slot></slot>
		</main>
	</section>
</template>

<script>
export default {
	name: 'grid-item',
	props: {
		title: {
			type: String
		}
	}
}
</script>

<style scoped>
.grid-group {}
.grid-group-title {
	color: #333;
	border-bottom: 1px solid #f0f0f0;
	font-size: 16px;
	font-weight: 700;
	margin: 20px 0 2rem 0;
	padding: 0 0 0.7rem 0;
	position: relative;
	font-weight: 900;
	letter-spacing: .05rem;
	display: flex;
	align-items: center;
}
.grid-group-title:after {
	content: ' ';
	display: block;
	height: 4px;
	width: 25px;
	background-color: var(--main-color);
	position: absolute;
	bottom: -4px;
}
.grid-group-title__title {
	flex: 1;
}
.grid-group-title__options {

}
</style>


// WEBPACK FOOTER //
// src/modules/ui/GridGroup.vue